const routes = {
  path: 'documents',
  component: () => import('@/modules/obu-documents/index.vue'),
  children: [
    {
      path: '',
      name: 'obu-documents',
      component: () => import('@/modules/obu-documents/ObuInvoicingDocumentsList.vue')
    },
    {
      path: ':did',
      name: 'obu-documents-details',
      component: () => import('@/modules/obu-documents/ObuInvoicingDocumentsDetails.vue'),
      children: []
    }
  ]
}

export default routes
